/**
 * Stored JSON → a text mix or a policy (moved out of text-policy,
 * 19/10/2026): anything that is not a mix is dropped.
 * For Media Devoted | Created By Ciro Autiero
 */
import { clampMix, DROP_GEN_POLICY_KINDS, DROP_GEN_TEXTS_PER_DROP_MAX, type DropGenTextMix, type DropGenTextPolicy } from "../text-policy";

const whole = (v: unknown, max: number): number | null =>
  typeof v === "number" && Number.isFinite(v) ? Math.min(max, Math.max(0, Math.round(v))) : null;

/** Stored JSON → a mix, or null when it is not one. */
export function parseMix(json: unknown): DropGenTextMix | null {
  if (typeof json !== "object" || json === null) return null;
  const r = json as { proven?: unknown; ai?: unknown };
  const proven = whole(r.proven, DROP_GEN_TEXTS_PER_DROP_MAX);
  const ai = whole(r.ai, DROP_GEN_TEXTS_PER_DROP_MAX);
  if (proven === null && ai === null) return null;
  return clampMix({ proven: proven ?? 0, ai: ai ?? 0 });
}

/** Stored JSON → a policy; anything that is not a mix is dropped. */
export function parseTextPolicy(json: unknown): DropGenTextPolicy {
  if (typeof json !== "object" || json === null) return {};
  const r = json as Record<string, unknown>;
  const out: DropGenTextPolicy = {};
  for (const k of DROP_GEN_POLICY_KINDS) {
    const mix = parseMix(r[k]);
    if (mix) out[k] = mix;
  }
  return out;
}
